import { CountryCode } from "libphonenumber-js";
import { PaymentMethodsStatus } from "src/utils/enums/payment-method-status.enum";

export interface CompanyMembers {
  id: number;
  role: string;
  firstName: string;
  lastName: string;
  email: string;
  status: string;
}

export interface Domain {
  name: string;
  id: string;
}

export interface PafValues {
  address: string;
  city: string;
  companyName: string;
  consent: boolean;
  eSignatureFullName: string;
  eSignatureTitle: string;
  email: string;
  naicsNumber: string;
  parentCompany: string;
  phone: string;
  state: string;
  uspsMailerId: string;
  websiteUrl: string;
  zipCode: string;
}

export interface CompanyInfo {
  name: string;
  companyPhoneNumber: string;
  addressOne: string;
  addressTwo: string;
  websiteUrl: string;
  city: string;
  state: string;
  zipCode: string;
  countryCode: CountryCode;
  domains: Domain[];
  id: number | null;
}

export interface EditCompanyInfoDto {
  name: string;
  companyPhoneNumber: string;
  addressOne: string;
  addressTwo: string;
  websiteUrl: string;
  city: string;
  state: string;
  zipCode: string;
  domains: {
    deleteIds: any[];
    domainNames: any[];
  };
}

export interface UserProfileInfoDto {
  firstName: string;
  lastName: string;
  cellPhoneNumber?: string;
  directOfficePhoneNumber?: string;
  countryCode: string;
}

export interface NewUserForm {
  value: string;
  successMsg: string;
  errorMsg: string;
}

export interface AutoExclusionForm {
  value: string;
}

export interface DescriptionForm {
  value: string;
}

export interface PafResponse {
  createdAt: string;
  id: number;
  companyName: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  phone: string;
  naicsNumber: string;
  email: string;
  websiteUrl: string;
  uspsMailerId: string;
  parentCopmany: string | null;
  eSignatureFullName: string;
  eSignatureTitle: string;
  expiredAt: string;
}

export interface Company {
  members: CompanyMembers[];
  info: CompanyInfo;
  newUserForm: NewUserForm;
  autoExclusionForm: AutoExclusionForm;
  descriptionForm: DescriptionForm;
  loadingTable: boolean;
  fetchError: string;
  isProcessingInvitation: boolean;
  paymentMethods: any[];
  printCredits: any;
  documentDescriptions: { id: number; orderNum: number; text: string }[];
  paf: PafResponse | null;
  editingPaymentMethod: boolean;
  isAttachingPaymentMethod: boolean;
  paymentMethodsStatus: PaymentMethodsStatus;
}

export const initialState: Company = {
  members: [],
  info: {
    name: '',
    companyPhoneNumber: '',
    addressOne: '',
    addressTwo: '',
    websiteUrl: '',
    countryCode: 'US',
    city: '',
    state: '',
    zipCode: '',
    domains: [],
    id: null,
  },
  newUserForm: {
    value: '',
    errorMsg: '',
    successMsg: '',
  },
  autoExclusionForm: {
    value: '',
  },
  descriptionForm: { value: '' },
  loadingTable: true,
  fetchError: '',
  isProcessingInvitation: false,
  paymentMethods: [],
  documentDescriptions: [],
  printCredits: '',
  paf: null,
  editingPaymentMethod: false,
  isAttachingPaymentMethod: false,
  paymentMethodsStatus: PaymentMethodsStatus.UNKNOWN,
};
